import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReactMarkdown from "react-markdown";

interface MarkdownRendererProps {
  content: string;
  isUser?: boolean;
}

const MarkdownRenderer = ({ content, isUser = false }: MarkdownRendererProps) => {
  const theme = useTheme();

  const customComponents = {
    p: ({ children }: any) => (
      <Typography
        variant="body1"
        sx={{
          mb: 1,
          textAlign: "left",
          whiteSpace: "normal",
          wordBreak: "break-word",
          color: isUser ? "primary.contrastText" : "text.primary",
          fontSize: 15
        }}
      >
        {children}
      </Typography>
    ),
    ul: ({ children }: any) => (
      <Box
        component="ul"
        sx={{
          pl: 2.5,
          mb: 1,
          color: isUser ? "primary.contrastText" : "text.primary"
        }}
      >
        {children}
      </Box>
    ),
    ol: ({ children }: any) => (
      <Box
        component="ol"
        sx={{
          pl: 2.5,
          mb: 1,
          color: isUser ? "primary.contrastText" : "text.primary"
        }}
      >
        {children}
      </Box>
    ),
    li: ({ children }: any) => (
      <Typography
        component="li"
        variant="body1"
        sx={{
          mb: 0.5,
          fontSize: 15,
          color: isUser ? "primary.contrastText" : "text.primary"
        }}
      >
        {children}
      </Typography>
    ),
    strong: ({ children }: any) => (
      <Box
        component="strong"
        sx={{
          fontWeight: 700,
          color: isUser ? "primary.contrastText" : theme.palette.text.primary
        }}
      >
        {children}
      </Box>
    )
  };

  return (
    <ReactMarkdown components={customComponents}>
      {content || ""}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;

